import React from "react";
import Sidebar from "../Common/component/Sidebar";
import Navbar from "../Common/component/Navbar";

import CustomerCreationForm from "../Common/component/CustomerCreationForm/CustomerCreationForm";

export default function CustomerCreation() {
  return (
    <>
      <section className="customerMainSection">
        <div className="container-fluid">
          <div className="row p-0">
            <div className="col-lg-2 p-0">
              <Sidebar />
            </div>
            <div className="col-lg-10  p-0">
              <div className="row">
                <div className="col-lg-12 p-0">
                  <Navbar />
                </div>
                <div className="col-lg-12 ">
                  {/* { <EmployecreationForm/> } */}
                  {<CustomerCreationForm />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
